import { initReduxSubscriber } from './redux-subscriber.js';
import { CHAT_TYPE_OFFLINE } from './const.js';

// https://redux-toolkit.js.org/
// https://unpkg.com/browse/@reduxjs/toolkit@1.2.5/dist/
export function initStore(ui_emitter) {

  // all performers
  const performers = RTK.createSlice({
    name: 'performers',
    initialState: [],
    reducers: {
      receive_performers: (state, action) => action.payload,
      performer_join: (state, action) => {
        const performer = action.payload;
        const index = state.findIndex(p => p.id === performer.id);
        if (index === -1) {
          state.push(performer);
        } else {
          return [
            ...state.slice(0, index),
            ...state.slice(index+1),
            performer
          ]
        }
      },
      performer_leave: (state, action) => {
        state.some(p => {
          if (p.id == action.payload.user_id) {
            p.status = 'offline';
            return true;
          }
        })
      },
      performer_true_private_setting: (state, action) => {
        state.some(p => {
          if (p.id == action.payload.user_id) {
            p.true_private_setting = action.payload.true_private_setting;
            return true;
          }
        });
      },
      performer_change_status: (state, action) => {
        state.some(p => {
          if (p.id == action.payload.user_id) {
            p.status = action.payload.user_status;
            return true;
          }
        });
      },
      performer_change_vibratip: (state, action) => {
        state.some(p => {
          if (p.id == action.payload.user_id) {
            p.vibratip = action.payload.user_vibratip_setting;
            return true;
          }
        });
      },
      performer_add_stream: (state, action) => {
        state.some(p => {
          if (p.id == action.payload.user_id) {
            let streams = p.streams || [];
            p.streams = appendStream(streams, action.payload.stream);
            return true;
          }
        });
      },
      performer_delete_stream: (state, action) => {
        state.some(p => {
          if (p.id == action.payload.user_id) {
            let newStreams = []; // if streamId is null - delete all streams
            const deleteStreamId = action.payload.stream_id;
            if (deleteStreamId != null) {
              newStreams = p.streams.filter(s => s.stream_id !== deleteStreamId);
            }
            p.streams = newStreams;
            return true;
          }
        });
      },
      all_performers_delete_streams: (state) => {
        state.forEach(p => {
          p.streams = [];
        })
      },
      performer_pledge_configuration: (state, action) => {
        state.some(p => {
          if (p.id == action.payload.user_id) {
            p.pledge_configuration = action.payload.pledge_configuration;
            return true;
          }
        });
      },
    }
  });

  function appendStream(list, stream) {
    const index = list.findIndex(s => s.stream_id === stream.stream_id);
    let allStreams = [];
    if (index === -1) {
      allStreams = [...list, stream];
    } else {
      allStreams = [
        ...list.slice(0, index),
        ...list.slice(index + 1),
        stream
      ];
    }
    return allStreams;
  }

  // current performer
  const performer = RTK.createSlice({
    name: 'performer',
    initialState: {},
    reducers: {
      receive_performer: (state, action) => {
        return action.payload;
      }
    },
    extraReducers: {
      [performers.actions.receive_performers]: (state, action) => {
        action.payload.some(p => {
          if (state.id == p.id) {
            state.status = p.status;
            state.vibratip = p.vibratip;
            state.pledge_configuration = p.pledge_configuration;
            state.public_room = p.public_room;
            state.streams = p.streams;
            state.tariff = p.tariff;
            return true;
          }
        })
      },
      [performers.actions.performer_join]: (state, action) => {
        const performer = action.payload;
        if (state.id == performer.id) {
          return performer;
        }
        return state;
      },
      [performers.actions.performer_leave]: (state, action) => {
        if (state.id == action.payload.user_id) {
          state.status = 'offline';
        }
      },
      [performers.actions.performer_true_private_setting]: (state, action) => {
        if (state.id == action.payload.user_id) {
          state.true_private_setting = action.payload.true_private_setting;
        }
      },
      [performers.actions.performer_change_status]: (state, action) => {
        if (state.id == action.payload.user_id) {
          state.status = action.payload.user_status;
        }
      },
      [performers.actions.performer_change_vibratip]: (state, action) => {
        if (state.id == action.payload.user_id) {
          state.vibratip = action.payload.user_vibratip_setting;
        }
      },
      [performers.actions.performer_add_stream]: (state, action) => {
        if (state.id == action.payload.user_id) {
          let streams = state.streams || [];
          state.streams = appendStream(streams, action.payload.stream);
        }
      },
      [performers.actions.performer_delete_stream]: (state, action) => {
        const performerId = action.payload.user_id;
        const streamId = action.payload.stream_id;
        if (performerId == null && streamId == null) {
          state.streams = [];
        } else {
          let newStreams = []; // if streamId is null - delete all streams
          if (streamId != null && state.streams) {
            newStreams = state.streams.filter(s => s.stream_id !== streamId);
          }
          state.streams = newStreams;
        }
      },
      [performers.actions.all_performers_delete_streams]: (state) => {
        state.streams = [];
      },
      [performers.actions.performer_pledge_configuration]: (state, action) => {
        if (state.id == action.payload.user_id) {
          state.pledge_configuration = action.payload.pledge_configuration;
        }
      }
    }
  });

  const defaultRoomTopic = ''; // redux topic better be different from server topic, to trigger change event
  const chat = RTK.createSlice({
    name: 'chat',
    initialState: {
      room: null,
      type: CHAT_TYPE_OFFLINE,
      topic: defaultRoomTopic,
      users: [],
      usersUpdateTimeout: 0,
      usersUpdateCount: 0, // for subscriber to listen to redux fully changed the state
      messages: [],
      app_panel: null,
    },
    reducers: {
      room: (state, action) => { state.room = action.payload },
      type: (state, action) => { state.type = action.payload },
      chat_reset: (state) => {
        state.topic = defaultRoomTopic;
        state.users = [];
        state.messages = [];
      },
      topic: (state, action) => { state.topic = action.payload },
      history: (state, action) => {
        state.messages = action.payload;
        ui_emitter.dispatchEvent(new Event('chat_clear_messages'));
        state.messages.forEach(m => {
          ui_emitter.dispatchEvent(new CustomEvent('chat_message_' + m.type, {detail: m}));
        })
      },
      message: (state, action) => {
        state.messages.push(action.payload);
        ui_emitter.dispatchEvent(new CustomEvent('chat_message_' + action.payload.type, {detail: action.payload}));
      },
      clear_messages: (state, action) => {
        state.messages = [];
        ui_emitter.dispatchEvent(new Event('chat_clear_messages'));
      },
      clear_user_messages: (state, action) => {
        const clear_name = action.payload;
        let needUpdateUI = false;
        const filtered = state.messages.filter(m => {
          const silence = (m.senderName && m.senderName == clear_name) || (m.userName && m.userName == clear_name);
          if (!needUpdateUI && silence) needUpdateUI = true;
          return !silence;
        });
        if (needUpdateUI) {
          state.messages = filtered;
          ui_emitter.dispatchEvent(new Event('chat_clear_messages'));
          state.messages.forEach(m => {
            ui_emitter.dispatchEvent(new CustomEvent('chat_message_' + m.type, {detail: m}));
          })
        }
      },
      app_panel: (state, action) => {
        state.app_panel = action.payload.panel;
      },
      users: (state, action) => {
        state.users = action.payload.sort(usersSortFunction);
        state.usersUpdateTimeout = 0;
        state.usersUpdateCount++;
      },
      join: (state, action) => {
        const user = action.payload;
        const newUsers = state.users.slice();
        newUsers.push(user);
        state.users = newUsers.sort(usersSortFunction);
        let timeout = usersTimeoutGuest;
        if (user.level === 'model') timeout = usersTimeoutPerformer;
        else if (user.level === 'basic' || user.level === 'premium' || user.level === 'admin') timeout = usersTimeoutMember;
        state.usersUpdateTimeout = timeout;
        state.usersUpdateCount++;
      },
      leave: (state, action) => {
        const user = action.payload;
        state.users = state.users.filter(u => u.id != user.id);
        const users_count = state.users.length;
        ui_emitter.dispatchEvent(new CustomEvent('chat_user_leave', {detail: {user, users_count}}));
      },
    }
  });

  const usersTimeoutPerformer = 0;
  const usersTimeoutMember = 1000;
  const usersTimeoutGuest = 5000;
  let usersLastSent = new Date();
  let usersTimer = null;

  function sendEventChatUsersList(users, timeout) {
    if (timeout === 0) {
      clearTimeout(usersTimer);
      usersTimer = null;
      ui_emitter.dispatchEvent(new CustomEvent('chat_users', {detail:{users}}));
      usersLastSent = new Date();
      return;
    }

    const timePassed = new Date() - usersLastSent;

    if (timePassed >= timeout) {
      clearTimeout(usersTimer);
      usersTimer = null;
      ui_emitter.dispatchEvent(new CustomEvent('chat_users', {detail:{users}}));
      usersLastSent = new Date();

    } else {
      const timeToNextUpdate = timeout - timePassed;
      if (usersTimer) {
        clearTimeout(usersTimer);
        usersTimer = null;
      }
      usersTimer = setTimeout(() => {
        sendEventChatUsersList(users, 0)
      }, timeToNextUpdate);
    }
  }

  function usersSortFunction(u1, u2) {
    if (u1) {
      if (u1.level === u2.level) {
        if (u1.level === 'guest') {
          const d1 = u1.username.indexOf('Guest') === 0;
          const d2 = u2.username.indexOf('Guest') === 0;
          if (d1 && !d2) return 1;
          if (!d1 && d2) return -1;
        }

        if (u1.tier_level === u2.tier_level) {
          return u1.username < u2.username ? -1 : 1;
        }

        if (u1.tier_level !== u2.tier_level) {
          return u1.tier_level < u2.tier_level ? 1 : -1;
        }
      }

      if (u1.level === 'model') return -1;
      if (u2.level === 'model') return 1;

      if (u1.level === 'premium') return -1;
      if (u2.level === 'premium') return 1;

      if (u1.level === 'basic') return -1;
      if (u2.level === 'basic') return 1;
    }

    return 0;
  }

  const pledgeBids = RTK.createSlice({
    name: 'pledgeBids',
    initialState: {},
    reducers: {
      pledgeBids: (state, action) => { return action.payload },
      pledgeBidAdded: (state, action) => {
        const { user_id, tokens } = action.payload;
        if (state[user_id]) {
          state[user_id].tokens += tokens;
        } else {
          state[user_id] = {user_id, tokens};
        }
      },
      pledgeBidClear: (state, action) => {
        const user_id = action.payload;
        if (state[user_id]) {
          delete state[user_id];
        }
      },
      pledgeChatInfo: (state, action) => {
        const { user_id, pledge_chat_info } = action.payload;
        // user might pledge other performer, forget about it and switch to another room
        if (!state[user_id]) {
          console.warn('user_forgot_about_pledge_show');
          console.error('trying to change pledge chat info with no bids', user_id, pledge_chat_info);
          sentryCaptureMessage('trying to change pledge chat info with no bids', pledge_chat_info);
          return state;
        }
        state[user_id].pledge_chat_info = pledge_chat_info;
      },
    }
  });

  const user = RTK.createSlice({
    name: 'user',
    initialState: {},
    reducers: {
      receive_user: (state, action) => { return action.payload },
      update_user_from_chat_server: (state, action) => {
        let tokens = parseInt(action.payload.tokens, 10);
        if (tokens < 0 || isNaN(tokens)) {
          console.warn('incorrect tokens from chat server', action.payload.tokens);
          tokens = 0;
        }
        state.tokens = tokens;
        state.ip = action.payload.ip;
        const publish_stream_names = action.payload.publish_stream_names;
        state.publish_stream_names = publish_stream_names;
        // webrtc_publish_stream_name, for user to publish the video
        let webrtcPSN = null;
        if (publish_stream_names && publish_stream_names.length) {
          publish_stream_names.some(ps => {
            if (ps.stream_type === 'webrtc') {
              webrtcPSN = ps.stream_name;
              return true;
            }
          });
        }
        state.webrtc_publish_stream_name = webrtcPSN;
      },
      update_tokens: (state, action) => { state.tokens = action.payload },
      update_tier_level: (state, action) => { state.tier_level = action.payload },
      update_verification: (state, action) => { state.verification = action.payload },
      update_private_message_setting: (state, action) => { state.settings.s_private_message = action.payload }
    }
  });

  const hiddenCamAccess = RTK.createSlice({
    name: 'hiddenCamAccess',
    initialState: {},
    reducers: {
      update_access: (state, action) => {
        const { room, allowed } = action.payload;
        if (state[room]) {
          state[room].allowed = allowed;
        } else {
          state[room] = {room, allowed};
        }
      },
    },
    extraReducers: {
      [chat.actions.chat_reset]: () => {
        return {};
      }
    }
  });


  const initialCollocutor = {
    id: null,
    username: null,
    photo: false,
    gender: 'female',
    isAdmin: false,
    messages: [],
    opened: false,
    unread: false,
    bar: false, // visible in chat bar
    ready: false
  };

  // helper to convert proxy to plain object
  const proxy2obj = p => JSON.parse(JSON.stringify(p));

  const messenger = RTK.createSlice({
    name: 'messenger',
    initialState: {
      muted: false, // play sound
      opened: false, // show chatters list
      collocutors: [],
    },
    reducers: {
      create_messenger: (state, action) => {
        const collocutor = action.payload;
        let existCollocutor = null;
        state.collocutors.some(c => {
          if (c.id == collocutor.id) {
            existCollocutor = c;
            return true;
          }
        });
        if (existCollocutor) return state;

        const needProps = {
          id: collocutor.id,
          username: collocutor.username,
          isAdmin: collocutor.isAdmin,
          photo: collocutor.photo || collocutor.has_photo,
        };
        const newCol = Object.assign({}, initialCollocutor, needProps);
        state.collocutors.push(newCol);
        ui_emitter.dispatchEvent(new CustomEvent('messenger_create', {detail: {collocutor: newCol}}));
      },
      open_messenger: (state, action) => {
        const colId = action.payload;
        // close others, open requested
        state.collocutors.forEach(c => {
          // other
          if (c.opened && c.id != colId) {
            if (c.opened) {
              c.opened = false;
              ui_emitter.dispatchEvent(new CustomEvent('messenger_close', {detail: {collocutor: proxy2obj(c)}}));
            }
          }
          // requested
          if (c.id == colId) {
            c.opened = true;
            c.unread = false;
            c.bar = true;
            ui_emitter.dispatchEvent(new CustomEvent('messenger_open', {detail: {collocutor: proxy2obj(c)}}));
          }
        })
      },
      messenger_ready: (state, action) => {
        const colId = action.payload;
        state.collocutors.some(c => {
          if (c.id == colId) {
            c.ready = true;
            ui_emitter.dispatchEvent(new CustomEvent('messenger_ready', {detail: {collocutor: proxy2obj(c)}}));
            return true;
          }
        });
      },
      messenger_offline: (state, action) => {
        const colId = action.payload;
        state.collocutors.some(c => {
          if (c.id == colId) {
            c.ready = false;
            ui_emitter.dispatchEvent(new CustomEvent('messenger_offline', {detail: {collocutor: proxy2obj(c)}}));
            return true;
          }
        });
      },
      toggle_messenger: (state, action) => {
        const colId = action.payload;
        let needCloseOthers = false;
        state.collocutors.some(c => {
          if (c.id == colId) {
            needCloseOthers = !c.opened;
            return true;
          }
        });
        state.collocutors.forEach(c => {
          if (c.id == colId) {
            c.opened = !c.opened;
            if (c.opened) {
              c.unread = false;
              ui_emitter.dispatchEvent(new CustomEvent('messenger_open', {detail: {collocutor: proxy2obj(c)}}));
            } else {
              ui_emitter.dispatchEvent(new CustomEvent('messenger_close', {detail: {collocutor: proxy2obj(c)}}));
            }
          } else {
            // close all others
            if (needCloseOthers && c.opened) {
              c.opened = false;
              ui_emitter.dispatchEvent(new CustomEvent('messenger_close', {detail: {collocutor: proxy2obj(c)}}));
            }
          }
        });
      },
      close_messenger: (state, action) => {
        const colId = action.payload;
        state.collocutors.some(c => {
          if (c.id == colId) {
            c.opened = false;
            ui_emitter.dispatchEvent(new CustomEvent('messenger_close', {detail: {collocutor: proxy2obj(c)}}));
            return true;
          }
        })
      },
      add_to_bar: (state, action) => {
        const colId = action.payload;
        state.collocutors.some(c => {
          if (c.id == colId) {
            c.bar = true;
            ui_emitter.dispatchEvent(new CustomEvent('messenger_add_to_bar', {detail: {collocutor: proxy2obj(c)}}));
            return true;
          }
        })
      },
      hide_from_bar: (state, action) => {
        const colId = action.payload;
        state.collocutors.some(c => {
          if (c.id == colId) {
            c.unred = false;
            c.bar = false;
            ui_emitter.dispatchEvent(new CustomEvent('messenger_hide_from_bar', {detail: {collocutor: proxy2obj(c)}}));
            return true;
          }
        })
      },
      history: (state, action) => {
        const { collocutorId, messages } = action.payload;
        state.collocutors.some(c => {
          if (c.id == collocutorId) {
            c.messages = messages;
            c.unread = !c.opened;
            ui_emitter.dispatchEvent(new CustomEvent('messenger_clear_messages', {detail: {collocutor: proxy2obj(c)}}));
            messages.forEach(message => {
              ui_emitter.dispatchEvent(new CustomEvent('messenger_message', {detail: {collocutor: proxy2obj(c), message, muted: true}}));
            });
            return true;
          }
        });
      },
      message: (state, action) => {
        const { collocutor, message } = action.payload;
        state.collocutors.some(c => {
          if (c.id == collocutor.id) {
            c.messages.push(message);
            c.unread = !c.opened;
            c.bar = true;
            ui_emitter.dispatchEvent(new CustomEvent('messenger_message', {detail: {collocutor: proxy2obj(c), message, muted: state.muted}}));
            return true;
          }
        });
      },
      messenger_unread: (state, action) => {
        const { collocutorId, unread } = action.payload;
        state.collocutors.some(c => {
          if (c.id == collocutorId) {
            c.unread = unread;
            ui_emitter.dispatchEvent(new CustomEvent('messenger_unread', {detail: {collocutor: proxy2obj(c)}}));
            return true;
          }
        });
      },
      toggle_chatters_list: (state) => {
        state.opened = !state.opened;
        ui_emitter.dispatchEvent(new CustomEvent('messenger_toggle_chatters_list', {detail: {opened: state.opened}}));
      },
      open_chatters_list: (state) => {
        state.opened = true;
        ui_emitter.dispatchEvent(new CustomEvent('messenger_toggle_chatters_list', {detail: {opened: state.opened}}));
      },
      close_chatters_list: (state) => {
        state.opened = false;
        ui_emitter.dispatchEvent(new CustomEvent('messenger_toggle_chatters_list', {detail: {opened: state.opened}}));
      },
      toggle_mute: (state) => {
        state.muted = !state.muted;
        ui_emitter.dispatchEvent(new CustomEvent('messenger_toggle_mute', {detail: {muted: state.muted}}));
      },
    }
  });

  const reducer = RTK.combineReducers({
    performers: performers.reducer, // all performers
    performer: performer.reducer, // current performer,
    chat: chat.reducer,
    pledgeBids: pledgeBids.reducer,
    user: user.reducer,
    hiddenCamAccess: hiddenCamAccess.reducer,
    messenger: messenger.reducer,
  });

  const store = RTK.configureStore({reducer: reducer});

  const initSubscriber = initReduxSubscriber();
  const subscribe = initSubscriber(store);

  subscribe('performer.vibratip', state => {
    console.log('rs performer.vibratip', state.performer.vibratip);
    ui_emitter.dispatchEvent(new CustomEvent('performer_vibratip', {detail: {performer: state.performer}}));
  });

  subscribe('performer.status', state => {
    const { performer, chat, hiddenCamAccess } = state;
    console.log('rs performer.status', performer.status);
    let camAccess = false;
    const room = chat.room;
    const hca = hiddenCamAccess;
    if (room in hca) camAccess = hca[room].allowed;
    const detail = { performer, camAccess };
    ui_emitter.dispatchEvent(new CustomEvent('chat_' + chat.type + '_performer_' + performer.status, {detail}));
  });

  subscribe('performer.streams', state => {
    ui_emitter.dispatchEvent(new CustomEvent('performer_streams', {detail: {performer: state.performer}}));
  });

  subscribe('chat.app_panel', state => {
    ui_emitter.dispatchEvent(new CustomEvent('app_panel', {detail: {app_panel: state.chat.app_panel}}));
  });

  subscribe('chat.usersUpdateCount', state => {
    const { users, usersUpdateTimeout } = state.chat;
    sendEventChatUsersList(users.slice(), usersUpdateTimeout);
  });

  subscribe('chat.topic', state => {
    const { topic } = state.chat;
    ui_emitter.dispatchEvent(new CustomEvent('topic', {detail: {topic}}));
  });

  subscribe('user.tokens', state => {
    const { tokens } = state.user;
    ui_emitter.dispatchEvent(new CustomEvent('user_tokens_left', {detail: {tokens}}));
  });

  subscribe('hiddenCamAccess', state => {
    const { hiddenCamAccess, chat, performer } = state;
    let camAccess = false;
    if (chat.room && chat.room in hiddenCamAccess) camAccess = hiddenCamAccess[chat.room].allowed;
    ui_emitter.dispatchEvent(new CustomEvent('performer_hidden_cam_access', {detail: {performer, camAccess}}));
  });

  subscribe('messenger', state => {
    let haveUnread = false;
    // save messenger state
    const save = Object.assign({}, state.messenger);
    save.collocutors.forEach(c => {
      c.messages = [];
      c.ready = false;
      if (c.unread) haveUnread = true;
    });
    save.save_time = new Date().getTime();
    save.save_user_id = state.user.id;
    localStorageSet('messenger', save);
    ui_emitter.dispatchEvent(new CustomEvent('messenger_have_any_unread', {detail: {unread: haveUnread}}));
  });

  return {
    store,
    subscribe,
    // slices:
    performers,
    performer,
    chat,
    pledgeBids,
    user,
    hiddenCamAccess,
    messenger,
  };
}
